import React from "react"
import { Link } from "gatsby"
import parse from "html-react-parser"
import ImageShow from "../../../ImageShow/showImage"
import * as style from "./footerTop.module.css"

const FooterTop = ({
  footerSvgLogoShow,
  footerContent,
  footerSocialTitle,
  footerMenuList,
  footerLogo,
  footerSocialIcons,
  footerImage,
}) => {
  return (
    <div className={style.footer_top_section}>
      <div className={style.left_footer}>
        <Link to="/" >
          {footerSvgLogoShow === "yes" ? (
            <ImageShow
              imageData={
                footerImage.mediaItemUrl ?? "/images/placeholder-image.jpg"
              }
              alt="logo"
            />
          ) : (
            <> {parse(`${footerLogo}`)} </>
          )}
        </Link>
        <div>
          <p>{footerContent}</p>
          <div>
            <div className={style.footer_heading}>{footerSocialTitle}</div>
            <ul className={style.footer_social}>
              {footerSocialIcons?.map((item, index) => {
                return (
                  <li key={index}>
                    <Link to={item?.footerIconLink?.url}>
                      {parse(`${item?.footerIcon}`)}
                    </Link>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </div>
      <div className={style.right_footer}>
        {footerMenuList?.map((item, index) => {
          return (
            <div className={style.right_footer_box}>
              <div className={style.footer_heading}>
                {item?.footerMenuListTitle}
              </div>
              <ul className={style.footer_list}>
                {item?.menuList?.map((item, index) => {
                  return (
                    <li key={index}>
                      {" "}
                      <Link to={item?.footerMenuListLink?.url}>
                        {item?.footerMenuListTitle}
                      </Link>
                    </li>
                  )
                })}
              </ul>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default FooterTop
